import React, { useState } from "react";
import { MainInput } from "../components/Core/mainInput";
import { Button } from "antd";

function AddNetwork({ onAdd }) {
  const [{ name, color, chainId, blockExplorer, rpcUrl }, setInfo] = useState({
    name: "",
    color: "",
    chainId: "",
    blockExplorer: "",
    rpcUrl: "",
  });

  return (
    <div
      style={{
        borderTop: "1px solid #f0f0f0",
        paddingTop: "10px",
        marginTop: "10px",
        borderBottom: "1px solid #f0f0f0",
        paddingBottom: "10px",
        marginBottom: "10px",
      }}
    >
      <MainInput placeholder="name" value={name} onChange={e => setInfo(old => ({ ...old, name: e.target.value }))} />
      <MainInput
        placeholder="color"
        value={color}
        onChange={e => setInfo(old => ({ ...old, color: e.target.value }))}
      />
      <MainInput
        placeholder="chain ID"
        value={chainId}
        onChange={e => setInfo(old => ({ ...old, chainId: e.target.value }))}
      />
      <MainInput
        placeholder="block explorer"
        value={blockExplorer}
        onChange={e => setInfo(old => ({ ...old, blockExplorer: e.target.value }))}
      />
      <MainInput
        placeholder="rpc url"
        value={rpcUrl}
        onChange={e => setInfo(old => ({ ...old, rpcUrl: e.target.value }))}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          type="primary"
          className="primary"
          size="large"
          disabled={!name || !color || !chainId || !blockExplorer || !rpcUrl}
          onClick={() =>
            onAdd({
              name,
              color,
              chainId: parseInt(chainId),
              blockExplorer,
              rpcUrl,
            })
          }
          block
        >
          Add
        </Button>
      </div>
    </div>
  );
}

export default AddNetwork;
